import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import classNames from 'classnames';

import messages from 'aurora-translations';
import ADGMTextField from '../../../ADGMTextField';
import styles from './styles';

function FilterList(props) {
  const { classes, intl, formData, setActiveModal, handleChange } = props;

  const handleModalFilter = useCallback((name, title, multi = false) => {
    setActiveModal({ name, title, key: name, multi });
  }, []);

  return (
    <div className={classes.filterListContainer}>
      {/* Authroization */}

      <List className={classNames(classes.filterList, classes.plotField)}>
        <ADGMTextField
          id='passportNumber'
          name='passportNumber'
          variant='outlined'
          placeholder={intl.formatMessage({ ...messages.Passport_number })}
          label={intl.formatMessage({ ...messages.Passport_number })}
          value={formData.passportNumber}
          onChange={handleChange}
        />
      </List>

      <List className={classes.filterList}>
        <ListItem
          button
          onClick={() => handleModalFilter('nationalityId', 'Nationalities')}
          disabled={isEmpty(formData.passportNumber)}
        >
          <ListItemText primary='Nationalities' />
          <ChevronRightIcon color='secondary' />
        </ListItem>
      </List>

      <List className={classNames(classes.filterList, classes.plotField)}>
        <ADGMTextField
          id='email'
          name='email'
          variant='outlined'
          placeholder={intl.formatMessage({ ...messages.Email })}
          label={intl.formatMessage({ ...messages.Email })}
          value={formData.email}
          onChange={handleChange}
        />
      </List>

      <List className={classNames(classes.filterList, classes.plotField)}>
        <ADGMTextField
          id='mobileNumber'
          name='mobileNumber'
          variant='outlined'
          placeholder={intl.formatMessage({ ...messages.mobile })}
          label={intl.formatMessage({ ...messages.mobile })}
          value={formData.mobileNumber}
          onChange={handleChange}
        />
      </List>
    </div>
  );
}

FilterList.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  setActiveModal: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(memo(FilterList));
